import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWritePoliticallyExposedPersonInformation: Map<string, ConfirmationData> = new Map([
    ["0cadb6bf-a063-40b5-8a7c-85b3dc9609eb", { hidden: true }],
    ["3a724709-7353-428a-a836-78b6c3061db1|8faec9ac-5cc2-492e-9576-1080d1a84a94", { hidden: true }],
]);



